module.exports = __webpack_public_path__ + "static/img/tag-coupon-expried.436dcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-coupon-expried.png
// module id = 347
// module chunks = 7